import React, { useState } from "react";
import {
  logoFacebook,
  logoInstagram,
  briefcase,
  logoLinkedin,
  layers,
  people,
  lockClosed,
  newspaper,
  mail,
  close,
  reader,
  logoWhatsapp,
} from "ionicons/icons";
import { useStringToast } from "../app/hooks";
import { Clipboard } from "@capacitor/clipboard";

import { contactSupport } from "../types/constants";
import { useAppSelector } from "../app/hooks";
import { mobileWidthBreakpoint } from "../types/form_table_data_types";
import {
  IonIcon,
  IonGrid,
  IonCol,
  IonRow,
  IonContent,
  useIonAlert,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
} from "@ionic/react";
import "./styles/VypzeeFooter.css";
const VypzeeFooter: React.FC<{
  marketDomain?: string;
  getParamsUrlForHome?: (isMid: boolean) => string;
}> = (props) => {
  console.log("vypzee footer props", props.getParamsUrlForHome);

  const isMobile =
    useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;
  const [aboutVypzeeOpen, setAboutVypzeeOpen] = useState(false);
  const presentStringToast = useStringToast();
  const [presentAlert] = useIonAlert();

  const closeAboutVypzee = () => {
    setAboutVypzeeOpen(false);
  };

  const AboutVypzee = (
    <>
      <IonModal isOpen={aboutVypzeeOpen} onDidDismiss={closeAboutVypzee}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{"About vypzee"}</IonTitle>
            <IonButtons slot="end">
              <IonButton
                fill="clear"
                color={"danger"}
                onClick={closeAboutVypzee}
              >
                <IonIcon icon={close} />
                Close{" "}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div style={{ width: "100%", padding: "10px", color: "black" }}>
            <p>
              VypZee, Physical + Digital (Phygital), is the first no-tech
              platform powering your business with a digital presence along with
              the presence of your neighbors in the market. VypZee is enabling
              online presence and discovery of your business in hyper local
              context that you are located in. It’s digital discovery and
              physical purchase paradigm removes the problems of inventory
              management and dual operations by boosting the physical sales
              through hyper-local digital discovery.
              <br />
              You created a google listing, a Facebook page and an Instagram
              page and no new business is coming to you, ever wonder why?
              <br />
              Imagine a market which has all the businesses in the world, what
              are the chances that a customer will find your business while
              browsing this market? Almost zero, isn’t it? This is what your
              Google or Facebook or Instagram listing is. Now to be discoverable
              in this sea you need to spend more time and money on digital and
              social media marketing, which is endless, so you resign to the
              fact of being digitally invisible. Is this your story?
              <br />
              Physical businesses cater to customers in a hyper local space and
              benefit from the physical closeness of other businesses in the
              same hyper local space. What if this physical closeness is
              replicated in the digital world too, will your business benefit
              from this digital closeness !!!
              <br />
              Do you want your promotions to reach every customer exploring the
              market no matter where they were in the market or even if they are
              at home? VypZee’s Phygital presence enables exactly this by
              enabling customers to explore and discover the entire market on
              their phone.
              <br />
              If you manage a mall or a high street retail and if your customers
              could explore all the events/announcements and promotions at a
              glance and can even share it with friends and family, will it not
              increase the footfall in your market, will it not boost the
              rentals in your market? Imagine, this and much more when you
              on-board your market on VypZee, the first Physical + Digital
              platform.
            </p>

            <div className="about_vypzee_section_bullet_point">
              <p> Website</p>
              <a href="https://vypzee.com">vypzee.com</a>
            </div>

            <div className="about_vypzee_section_bullet_point">
              <p> Phone</p>
              <a href="tel:+919818783337">+91 98187 83337</a>
            </div>
            <div className="about_vypzee_section_bullet_point">
              <p> Industry</p>
              <p style={{ color: "grey" }}>Retail</p>
            </div>
            <div className="about_vypzee_section_bullet_point">
              <p> Headquarters</p>
              <p style={{ color: "grey" }}>Gurugram, Haryana</p>
            </div>
            <div className="about_vypzee_section_bullet_point">
              <p> Founded</p>
              <p style={{ color: "grey" }}>2020</p>
            </div>
            <div className="about_vypzee_section_bullet_point">
              <p> Specialties</p>
              <p style={{ color: "grey" }}>
                High street retail, Local markets, Local businesses, Malls &
                Retail Outlets, and Online business
              </p>
            </div>
          </div>
        </IonContent>
      </IonModal>
    </>
  );

  return (
    <>
      <IonGrid>
        <IonRow>
          <IonCol
            style={{
              display: "flex",
              justifyContent: "center",
            }}
            size={isMobile ? "0" : "4"}
          >
            <div
              onClick={() => {
                window.location.assign(`https://vypzee.com/`);
              }}
              className="vypzee_footer_lg_logo"
            >
              <img
                src="./assets/lg_vypzee_logo.avif"
                alt="vypzee_logo"
                loading="lazy"
              />
            </div>
          </IonCol>

          <IonCol className="vypzee_footer_col" size={isMobile ? "5.8" : "4"}>
            <div
              onClick={() => {
                window.location.assign(`https://vypzee.com/`);
              }}
              className="vypzee_footer_head"
            >
              <img
                src="./assets/vypzee_no_bg.png"
                alt="vypzee logo"
                loading="lazy"
              />
            </div>
            <div className="vypzee_footer_options">
              <a className="vypzee_footer_links">
                <IonIcon icon={briefcase} />
                <div
                  onClick={() => {
                    setAboutVypzeeOpen(true);
                  }}
                  style={{ marginLeft: "0.5rem" }}
                >
                  {" "}
                  About VypZee
                </div>
              </a>

              <a
                onClick={() =>
                  presentAlert({
                    header: "Our Team",
                    // subHeader: "Important message",
                    message: "This Feature is coming soon!",
                    buttons: ["OK"],
                  })
                }
                className="vypzee_footer_links"
              >
                <IonIcon icon={people} />
                <div style={{ marginLeft: "0.5rem" }}>Our Team</div>
              </a>

              <a
                onClick={async () => {
                  await Clipboard.write({
                    string: "info@idigizen.com",
                  });
                  presentStringToast("Link copied.");
                }}
                className="vypzee_footer_links"
              >
                <IonIcon icon={mail} />
                <div style={{ marginLeft: "0.5rem" }}>info@idigizen.com</div>
              </a>

              <div>
                <a
                  onClick={contactSupport.bind(this, "Hello team VypZee")}
                  className="vypzee_footer_social_links"
                  href=""
                >
                  <IonIcon icon={logoWhatsapp} />
                </a>
                <a
                  className="vypzee_footer_social_links"
                  href="https://www.instagram.com/vypzee/"
                >
                  <IonIcon icon={logoInstagram} />
                </a>
                <a
                  className="vypzee_footer_social_links"
                  href="https://www.linkedin.com/company/vypzee-an-idigizen-venture/"
                >
                  <IonIcon icon={logoLinkedin} />
                </a>
              </div>
            </div>
          </IonCol>
          <IonCol className="vypzee_footer_col" size={isMobile ? "5.8" : "4"}>
            <div
              className="vypzee_footer_head"
              style={{
                fontSize: isMobile ? "1.4rem" : "2rem",
              }}
            >
              Quick links
            </div>
            <div className="vypzee_footer_options">
              <a
                onClick={() => {
                  window.location.assign(`https://vypzee.com/`);
                }}
                className="vypzee_footer_links"
              >
                <IonIcon icon={layers} />
                <div style={{ marginLeft: "0.5rem" }}>Explore Markets</div>
              </a>
              <a
                onClick={() =>
                  window.location.assign(`https://vypzee.com/blog`)
                }
                className="vypzee_footer_links"
              >
                <IonIcon icon={reader} />
                <div style={{ marginLeft: "0.5rem" }}>Blogs</div>
              </a>
              <a
                onClick={() => {
                  window.location.assign(`./privacy-policy`);
                }}
                className="vypzee_footer_links"
              >
                <IonIcon icon={lockClosed} />
                <div style={{ marginLeft: "0.5rem" }}>Privacy Policy</div>
              </a>
              <a
                onClick={() => {
                  window.location.assign(`./terms-of-services`);
                }}
                className="vypzee_footer_links"
              >
                <IonIcon icon={newspaper} />
                <div style={{ marginLeft: "0.5rem" }}>Terms of Service</div>
              </a>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
      {AboutVypzee}
    </>
  );
};

export default VypzeeFooter;
